<template>
  <div class="payment-status-page">
    <AppAccessaryHeader class="payment-status-page__header" />
    <UkaskoLoader :is-loading="isLoadingStatus && !isPolling" class="payment-status-page__content">
      <PaymentSuccess
        v-if="isSuccess"
        :final-url="finalUrl"
        class="payment-status-page__success"
      />
      <PaymentWaiting
        v-else-if="isWaiting"
        :poll-attempts="pollAttempts"
        class="payment-status-page__waiting"
      />
      <PaymentFailed
        v-else-if="isFailed"
        :message="failureMessage"
        class="payment-status-page__failed"
      />
    </UkaskoLoader>
    <AppAccessaryFooter class="payment-status-page__footer" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { PaymentFailed, PaymentSuccess, PaymentWaiting } from '@/features/payment-status';
import { UkaskoLoader } from '@/shared/ui/ukasko-loader';
import { AppAccessaryFooter } from '@/widgets/app-accessary-footer';
import { AppAccessaryHeader } from '@/widgets/app-accessary-header';

export default {
  components: { AppAccessaryHeader, AppAccessaryFooter, UkaskoLoader, PaymentSuccess, PaymentFailed, PaymentWaiting },
  computed: {
    ...mapGetters('paymentStatusModule', [
      'isLoadingStatus',
      'isSuccess',
      'isFailed',
      'isWaiting',
      'isPolling',
      'failureMessage',
      'finalUrl',
      'pollAttempts',
    ]),
    invoiceId() {
      return this.$route.query.invoice;
    },
  },
  created() {
    this.loadCurrentUser().catch(() => {});

    if (!this.invoiceId) {
      this.$router.push('/');
      return;
    }

    this.checkPaymentStatus(this.invoiceId).catch((error) => {
      if (error?.response?.status === 404) {
        this.$router.push('/');
      }
    });
  },
  beforeDestroy() {
    this.stopPolling();
  },
  methods: {
    ...mapActions('currentUserModule', ['loadCurrentUser']),
    ...mapActions('paymentStatusModule', ['checkPaymentStatus', 'stopPolling']),
  },
};
</script>

<style scoped lang="scss">
.payment-status-page {
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  &__header {
    flex-shrink: 0;
  }

  &__content {
    display: flex;
    flex-grow: 1;
  }

  &__footer {
    flex-shrink: 0;
  }
}
</style>